import { default as agency } from './agency/agencyReducers';
import { default as alert } from './alert/alertReducers';
import { default as app } from './app/appReducers';
import { default as auth } from './auth/authReducers';
import { default as content } from './content/contentReducers';
import { default as language } from './language/languageReducers';
import { default as login } from './login/loginReducers';
import { default as mobileNav } from './mobileNav/mobileNavReducers';
import { default as modal } from './modal/modalReducers';
import { default as navbar } from './navbar/navbarReducers';
import { default as OTP } from './OTP/OTPReducers';
import { default as payment } from './payment/paymentReducers';
import { default as user } from './user/userReducers';
import { default as session } from './session/sessionReducers';
import { default as dps } from './agency/dlr/dlrReducers';
import { default as tdlr } from './agency/tdlr/tdlrReducers';
import { default as dmv } from './agency/dmv/dmvReducers';
import { default as tpwd } from './agency/tpwd/tpwdReducers';
import { default as appHistory } from './appHistory/appHistoryReducers';
import { default as messageBanner } from './messageBanner/messageBannerReducers';

export default [
  agency,
  alert,
  app,
  auth,
  content,
  language,
  login,
  mobileNav,
  modal,
  navbar,
  OTP,
  user,
  session,
  payment,
  dps,
  tdlr,
  dmv,
  tpwd,
  appHistory,
  messageBanner,
];
